import * as styles from "./NameAndBio.module.css";

export default function NameAndBio() {
  return (
    <section className={styles.introSection}>
      <div className={styles.nameAndBioContainer}>
        <h1>Oluwatobi Sofela</h1>
        <div className={styles.bio}>
          a full-stack developer passionate about user-centric innovations
        </div>
      </div>
    </section>
  );
}
